export enum AppSnackbarCloseReasonEnum {
    Action = 'action',
    Timeout = 'timeout',
}